<template>
    <v-card>
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                {{$t('subjectreportlist')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <div class="text-right pa-1">
            <v-btn @click="exportToExcelWithRowspanColspan('PoliciesProgramBudget')" class="white--text" color="green">Export</v-btn>
        </div>
        <div class="text-center">
            <h4 >
                खाद्य व्यवस्था तथा व्यापार कम्पनी लिमिटेड
                <br />
                आ.ब {{fiscalyearName}}  को बार्षिक नीति तथा कार्यक्रम र बजेट
            </h4>
        </div>
        <v-card-text>
            <!--{{fiscalyearName}}-->
            <!--<table id="myTable" style="border-collapse:collapse;">
            <thead>
                <tr>
                    <th class="header-cell" rowspan="2">क्र.सं.</th>
                    <th class="header-cell" rowspan="2">विषय</th>
                    <th class="header-cell" rowspan="2">कार्यक्रम</th>
                    <th class="header-cell" rowspan="2">लक्ष्य</th>
                    <th class="header-cell" colspan="2">बजेट रु हजारमा</th>
                    <th class="header-cell" rowspan="2">जम्मा</th>
                    <th class="header-cell" rowspan="2">अनुसूची</th>
                    <th class="header-cell" rowspan="2">उपलब्धि</th>
                </tr>
                <tr>
                    <th class="header-cell">चालु</th>
                    <th class="header-cell">पूँजीगत</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(subject, subjectIndex) in rows">
                    <tr :key="'subject-'+subjectIndex">
                        <td class="header-cell subject-background" :rowspan="subject.targetCount+subject.programs.length+1">
                            {{subjectIndex +1}}
                        </td>
                        <td class="header-cell subject-background" :rowspan="subject.targetCount+subject.programs.length+1">
                            {{subject.subjectName}}
                        </td>
                    </tr>
                    <template v-for="(program, programIndex) in subject.programs">
                        <tr :key="'program-'+programIndex">
                            <td class="header-cell subject-background" :rowspan="program.targetCount+1">
                                {{program.programName}}
                            </td>
                        </tr>
                        <template v-for="(target, targetsIndex) in program.targets">
                            <tr :key="'target-'+targetsIndex">
                                <td class="header-cell subject-background">
                                    {{target.targetName}}
                                </td>
                                <td class="header-cell subject-background">{{target.currentAmount}}</td>
                                <td class="header-cell subject-background">{{target.capitalAmount}}</td>
                                <td class="header-cell subject-background">{{target.totalAmount}}</td>
                                <td class="header-cell subject-background">{{target.anusuchiName}}</td>
                                <td class="header-cell subject-background">{{target.achievement}}</td>
                            </tr>
                        </template>
                    </template>
                    <tr :key="'subject-total-'+subjectIndex">
                        <th class="header-cell subject-background-total" colspan="4">
                            <strong>
                                जम्मा
                            </strong>
                        </th>
                        <th class="header-cell subject-background-total"><strong>{{ subject.currentAmount }}</strong></th>
                        <th class="header-cell subject-background-total"><strong>{{ subject.capitalAmount }}</strong></th>
                        <th class="header-cell subject-background-total"><strong>{{ subject.totalAmount}}</strong></th>
                        <th class="header-cell subject-background-total" colspan="2"></th>
                    </tr>
                </template>
                <tr>
                    <th class="header-cell" colspan="4">
                        <strong>
                            जम्मा
                        </strong>
                    </th>
                    <th class="header-cell"><strong>{{ subjectTotal.currentAmount }}</strong></th>
                    <th class="header-cell"><strong>{{ subjectTotal.capitalAmount }}</strong></th>
                    <th class="header-cell"><strong>{{ subjectTotal.totalAmount}}</strong></th>
                    <th class="header-cell" colspan="2"></th>
                </tr>
            </tbody>


        </table>-->


            <table ref="myTable" id="myTable" style="border-collapse:collapse;">
                <thead>
                    <tr style="visibility: hidden;">
                        <th colspan="9">
                            <h4>
                                खाद्य व्यवस्था तथा व्यापार कम्पनी लिमिटेड
                            </h4>
                        </th>
                    </tr>
                    <tr style="visibility: hidden;">
                        <th colspan="9">
                            <h4>
                                आ.ब {{fiscalyearName}}  को बार्षिक नीति तथा कार्यक्रम र बजेट
                            </h4>
                        </th>
                    </tr>
                    <tr class="sticky-div">
                        <th class="header-cell" rowspan="2">क्र.सं.</th>
                        <th class="header-cell" rowspan="2">विषय</th>
                        <th class="header-cell" rowspan="2">कार्यक्रम</th>
                        <th class="header-cell" rowspan="2">लक्ष्य</th>
                        <th class="header-cell" colspan="2">बजेट रु हजारमा</th>
                        <th class="header-cell" rowspan="2">जम्मा</th>
                        <th class="header-cell" rowspan="2">अनुसूची</th>
                        <th class="header-cell" rowspan="2">उपलब्धि</th>
                    </tr>
                    <tr  class="sticky-div" style="top:43px;">
                        <th class="header-cell">चालु</th>
                        <th class="header-cell">पूँजीगत</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(subject, subjectIndex) in rows">
                        <tr :key="'subject-'+subjectIndex">
                            <td class="header-cell subject-background" :rowspan="subject.targetCount">
                                {{subjectIndex +1}}
                            </td>
                            <td class="header-cell subject-background" :rowspan="subject.targetCount" style="text-align:left !important;">
                                {{subject.subjectName}}
                            </td>
                            <template>
                                <td class="header-cell subject-background" :rowspan="subject.programs[0].targetCount" style="text-align:left !important;">{{ subject.programs[0].programName }}</td>
                            </template>
                            <template>
                                <td class="header-cell subject-background" :rowspan="subject.programs[0].targets[0].targetCount" style="text-align:left !important;">{{ subject.programs[0].targets[0].targetName }}</td>
                                <td class="header-cell subject-background">{{subject.programs[0].targets[0].currentAmount}}</td>
                                <td class="header-cell subject-background">{{subject.programs[0].targets[0].capitalAmount}}</td>
                                <td class="header-cell subject-background">{{subject.programs[0].targets[0].totalAmount}}</td>
                                <td class="header-cell subject-background">{{subject.programs[0].targets[0].anusuchiName}}</td>
                                <td class="header-cell subject-background">{{subject.programs[0].targets[0].achievement}}</td>
                            </template>
                        </tr>
                        <template v-for="(program, programIndex) in subject.programs">
                            <tr :key="'program-'+programIndex" v-if="!(programIndex ===0)">
                                <td class="header-cell subject-background" :rowspan="program.targetCount" style="text-align:left !important;">
                                    {{program.programName}}
                                </td>
                                <template>
                                    <td class="header-cell subject-background" style="text-align:left !important;">{{ program.targets[0].targetName }}</td>
                                    <td class="header-cell subject-background">{{program.targets[0].currentAmount}}</td>
                                    <td class="header-cell subject-background">{{program.targets[0].capitalAmount}}</td>
                                    <td class="header-cell subject-background">{{program.targets[0].totalAmount}}</td>
                                    <td class="header-cell subject-background">{{program.targets[0].anusuchiName}}</td>
                                    <td class="header-cell subject-background">{{program.targets[0].achievement}}</td>
                                </template>
                            </tr>
                            <template v-for="(target, targetsIndex) in program.targets">
                                <tr :key="'target-'+targetsIndex" v-if="!( targetsIndex ===0) ">
                                    <td class="header-cell subject-background" style="text-align:left !important;">
                                        {{target.targetName}}
                                    </td>
                                    <td class="header-cell subject-background">{{target.currentAmount}}</td>
                                    <td class="header-cell subject-background">{{target.capitalAmount}}</td>
                                    <td class="header-cell subject-background">{{target.totalAmount}}</td>
                                    <td class="header-cell subject-background">{{target.anusuchiName}}</td>
                                    <td class="header-cell subject-background">{{target.achievement}}</td>
                                </tr>
                            </template>
                        </template>
                        <tr :key="'subject-total-'+subjectIndex">
                            <th class="header-cell subject-background-total" colspan="4">
                                <strong>
                                    जम्मा
                                </strong>
                            </th>
                            <th class="header-cell subject-background-total"><strong>{{ subject.currentAmount }}</strong></th>
                            <th class="header-cell subject-background-total"><strong>{{ subject.capitalAmount }}</strong></th>
                            <th class="header-cell subject-background-total"><strong>{{ subject.totalAmount}}</strong></th>
                            <th class="header-cell subject-background-total" colspan="2"></th>
                        </tr>
                    </template>
                    <tr>
                        <th class="header-cell" colspan="4">
                            <strong>
                                जम्मा
                            </strong>
                        </th>
                        <th class="header-cell"><strong>{{ subjectTotal.currentAmount }}</strong></th>
                        <th class="header-cell"><strong>{{ subjectTotal.capitalAmount }}</strong></th>
                        <th class="header-cell"><strong>{{ subjectTotal.totalAmount}}</strong></th>
                        <th class="header-cell" colspan="2"></th>
                    </tr>
                </tbody>


            </table>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">{{$t('cancel')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    import { excelExport } from "../../../mixins/excelExport";
    export default {
        name: "ReportList",

        props: ["subjectReportViewData"],
        mixins: [excelExport],
        data() {
            return {
                role: this.$store.getters.getUserRole,
                rows: [],
                fiscalyearName: "",
                formData: {},
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    viewFormComponent: false,
                    editFormComponent: false,
                    dialogDelete: false,
                    dynamicComponent: {
                        current: 'SectionsForm'
                    }
                }
            };
        },

        methods: {

            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
                this.loadItems();
            },
            dialogueClose() {
                this.formData = {}
                this.$emit('dialogueCloseView')
            },
            async loadItems() {
                axios.get("ReportSettings/GetPoliciesProgramBudgetLevelTwoReport/" + this.subjectReportViewData.fiscalYearID).then(response => {
                    console.log('dasdad', response)
                    this.fiscalyearName = response.data.fiscalYearName
                    this.rows = response.data.policiesProgramBudgetReportModel
                })
            },
            
    
        },
        computed: {
            subjectTotal() {
                const sumData = {
                    currentAmount: 0,
                    capitalAmount: 0,
                    totalAmount: 0
                    }
                this.rows.map(res => {
                    sumData.currentAmount += res.currentAmount
                    sumData.capitalAmount += res.capitalAmount
                    sumData.totalAmount += res.totalAmount
                })
                return sumData
            },
            processedRows() {
                const processedRows = [];
                this.rows.forEach((subject) => {
                    subject.programs.forEach((program, programIndex) => {
                        processedRows.push({
                            subjectName: subject.subjectName,
                            programName: program.programName,
                            rowspanSubject: programIndex === 0 ? subject.targetCount : 0,
                            rowspanProgram: program.targetCount,
                        });
                    });
                });
                return processedRows;
            },
        },

        mounted() {
            this.loadItems()

        },

    }
</script>

<style scoped>
    .subject-background{
        background-color: white;
    }
    .subject-background-total {
        background-color: #abaed366
    }
</style>
